// Archimago pure helpers. No React, no Three.js.
//
// ── Codex (Archimago) ──
//   "Tap → Play or draw a site.
//
//    Banish three magic spells in your cemetery → Cast a copy of one of
//    them."
//
// The Tap line is the standard avatar builtin. The second clause is an
// activated ability with a non-mana, non-tap cost (banish three Magic
// cards from the controller's cemetery). GameBoard owns the imperative
// banish + the picker + the cast resolution; this module owns the
// read-only predicates and the cemetery query helpers.
//
// Catalog shape is the NORMALIZED card object emitted by
// `normalizeSorceryCard` (`type` is a top-level string). NOT the raw
// `public/sorcery-cards.json` shape.

function lookupCatalog(card, catalog) {
  if (!card || !Array.isArray(catalog)) return null;
  return catalog.find((c) => c?.unique_id === card.cardId) || null;
}

/** True iff `card` (a cemetery cardInstance) resolves to a Magic-type catalog card. */
export function isMagicSpell(card, catalog) {
  const full = lookupCatalog(card, catalog);
  return !!full && full.type === 'Magic';
}

/** Filter a cemetery's card list down to Magic spells. */
export function findMagicSpellsInCemetery(cemeteryCards, catalog) {
  return (cemeteryCards || []).filter((c) => isMagicSpell(c, catalog));
}

/** True iff the cemetery holds at least `count` Magic spells. */
export function cemeteryHasEnoughMagic(cemeteryCards, catalog, count = 3) {
  let seen = 0;
  for (const card of cemeteryCards || []) {
    if (isMagicSpell(card, catalog)) {
      seen += 1;
      if (seen >= count) return true;
    }
  }
  return false;
}
